import { Typography, Container, Box, Paper, ListItem, List, ListItemText, Divider, Skeleton, ListSubheader } from "@mui/material";
import NextBreadcrumbs from "../../component/NextBreadcrumbs";
import Page from "../../component/Page";
import React, { useEffect, useState } from "react";

const Publication = () => {
    const [data, setData] = useState(null);

    useEffect(() => {
        fetch("/KCC_Publications.json").then(res => res.json()).then(json => {
            // Group publications by YEAR
            const publicationsByYear = {};
            for (const item of json) {
                const year = item["YEAR"];
                const publication = item["PUBLICATION"]?.trim();
                if (year && publication) {
                    if (!(year in publicationsByYear)) {
                        publicationsByYear[year] = [];
                    }
                    publicationsByYear[year].push(publication);
                }
            }
            setData(publicationsByYear);
        });
    }, []);

    return (
        <Page>
            <Container sx={{ pt: 10, pb: 3 }}>
                <NextBreadcrumbs />
                <Typography variant="h3">Publication</Typography>
                <Typography variant="h6">Peer reviewed publications & book chapters</Typography>
                <Box sx={{ display: "flex", py: 1 }}>
                    <Typography sx={{ pr: 2 }}>* Undergraduate student</Typography>
                    <Typography sx={{ px: 2 }}>** Graduate student</Typography>
                    <Typography sx={{ px: 2 }}>*** Research Staff</Typography>
                    <Typography sx={{ pl: 2 }}>Post-doc</Typography>
                </Box>
                <Paper elevation={3}>
                    {data ?
                        <List dense sx={{ p: 2 }}>
                            {Object.keys(data).sort((a, b) => b - a).map((year) => (
                                <React.Fragment key={year}>
                                    <ListSubheader sx={{ bgcolor: "background.paper", fontWeight: "bold" }}>{year}</ListSubheader>
                                    {data[year].map((pub, idx) => (
                                        <React.Fragment key={`${year}_${idx}`}>
                                            {idx > 0 && <Divider component="li" />}
                                            <ListItem sx={{ height: 100 }}>
                                                <ListItemText sx={{ fontSize: 10 }}>
                                                    {pub}
                                                </ListItemText>
                                            </ListItem>
                                        </React.Fragment>
                                    ))}
                                </React.Fragment>
                            ))}
                        </List>
                        :
                        <>
                            <Box>
                                <Skeleton variant="rectangular" height={45} width={"100%"} />
                            </Box>
                            <List>
                                {[...Array(6)].map((_, idx) => (
                                    <ListItem key={"skeleton_" + idx} sx={{ display: "flex", justifyContent: "space-between" }}>
                                        <Skeleton variant="rectangular" height={45} width={"100%"} />
                                    </ListItem>
                                ))}
                            </List>
                        </>
                    }
                </Paper>
            </Container>
        </Page>
    );
};

export default Publication;
